import { observer } from 'mobx-react';
import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { ExperienceResource } from '../../../../../../../../../../../../Types';
import Heading from '../../../../../../../../../Heading';
import ExperienceHours from './ExperienceHours';
import OverviewPdfLink from './OverviewPdfLink';

export interface Props {
  resource: ExperienceResource;
}

const BodyLeft: React.FC<Props> = ({ resource }) => (
  <div className="basis-2/3">
    <Heading title={resource.payload.title.text} featured={resource.payload.featured} />
    <ExperienceHours resource={resource} />
    <div className="mb-4 text-sm">
      {ReactHtmlParser(resource.payload.publicDetailedDescriptionHtml)}
    </div>
    <OverviewPdfLink resource={resource} />
  </div>
);

export default observer(BodyLeft);
